document.addEventListener('turbo:load', () => {
  const select = document.getElementById('theme-select')
  const body = document.body

  if (!select) return

  const savedTheme = localStorage.getItem('theme') || 'light'
  body.classList.add(savedTheme === 'dark' ? 'dark-mode' : 'light-mode')
  select.value = savedTheme

  select.addEventListener('change', (e) => {
    const theme = e.target.value
    localStorage.setItem('theme', theme)

    body.classList.remove('light-mode', 'dark-mode')
    body.classList.add(theme === 'dark' ? 'dark-mode' : 'light-mode')
  })
})
